import { useContext, useEffect } from "react";
import { usersMicroserviceUrl } from "../../../../../microservices/users_microservice";
import { AppContext } from "../../../../AppProvider";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/EnablingCustomerUser.css";

const EnablingCustomerUser = ({customerUserStatusUpdate,setCustomerUserStatusUpdate,customerUser}) => {
    const {user} = useContext(AppContext);
    const enableCustomerUser = async () => {
        try{
            const url = `${usersMicroserviceUrl}/tenants/customer-users/${customerUser?.id}/status`;
            const response = await fetch(url, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.access_token}`,
                },
                body: JSON.stringify({ status: 'ACTIVE' }),
            });
            if (response.ok) {
                setCustomerUserStatusUpdate('enabled');
            } else {
                console.error('Failed to enable customer user:', response.statusText);
            }
        }
        catch(error){
            console.error('Unexpected error enabling customer user:', error);
        }
    };
    useEffect(() => {
        if(customerUserStatusUpdate === 'enabling'){
            enableCustomerUser();
        }
    }, [customerUserStatusUpdate]);
    return (
        <div>
            {
                customerUserStatusUpdate === 'enabling' ? 
                (
                    <div className="tenant-administrator-enabling-customer-user-container">
                        <div className="tenant-administrator-enabling-customer-user-loading-message">
                            <div className="tenant-administrator-enabling-customer-user-loading-spinner"></div>
                            <p>Enabling customer user. Please wait</p>
                        </div>
                    </div>
                ):
                customerUserStatusUpdate === 'enabled' ? (
                    <div className="tenant-administrator-enabling-customer-user-container">
                        <div className="tenant-administrator-enabling-customer-user-success-message">
                            <p>Customer user has been enabled successfully</p>
                            <div className="tenant-administrator-enabling-customer-user-success-button-container">
                                <button onClick={() => setCustomerUserStatusUpdate('updated')}>Okay</button>
                            </div>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-enabling-customer-user-container">
                        <div className="tenant-administrator-enabling-customer-user-error-message">
                            <p>An error occurred while enabling customer user</p>
                            <div className="tenant-administrator-enabling-customer-user-error-button-container">
                                <button onClick={() => setCustomerUserStatusUpdate('updated!')}>Okay</button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
}
export default EnablingCustomerUser;